// extracted by mini-css-extract-plugin
export default {"inputRequire":"mLlZGm9g95o45MXRzhCA","require":"uSiK2PQwhHieRltufWBU","common_bganimation":"uFTvXMveLlL0bFXzoGbX"};